import Sidebar from './Sidebar';
import Navbar from './Navbar';
import React from 'react';
import './style.css';
import Table from 'react-bootstrap/Table';

import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


const AddTea = () => {

    let history = useNavigate();

    const [data, setData] = useState({
        grade: "",
    })

    // start add product id from the database named products
    //const [productid, setProductid] = useState("");

    useEffect(() => {
        // Fetch the last productid and increment it
/*        
        axios.get("https://react-apis.dotlocalhost.com/getproductid.php")
            .then(response => {
                setProductid(response.data.productid); // Set the incremented productid
            })
            .catch(error => {
                console.error("There was an error fetching the productid!", error);
            });
*/            


        // Change background color of the specific sidebar item
        const sidebarItemmain = document.getElementById("teaprdct");
        if (sidebarItemmain) {
            sidebarItemmain.style.backgroundColor = "#C0D4D9"; // Set the color when this component is loaded
            sidebarItemmain.style.color = "#000000";
        }
        const sidebarItem = document.getElementById("addtea");
        if (sidebarItem) {
            sidebarItem.style.backgroundColor = "#CFE2E7"; // Set the color when this component is loaded
            sidebarItem.style.color = "#000000";
        }


        // Cleanup function to reset the background color when component unmounts
        return () => {
            if (sidebarItemmain) {
                sidebarItemmain.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItemmain.style.color = "#000000"
            }
            if (sidebarItem) {
                sidebarItem.style.backgroundColor = ""; // Reset to default when component unmounts
                sidebarItem.style.color = "#000000";
            }
        };
    }, []);
    // end add product id from the database named products

    const handleChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });

        //console.log(data)
    }

    const submitForm = (e) => {
        e.preventDefault();
        const sendData = {
            grade: data.grade,
        }

        console.log(sendData);

        axios.post('https://react-apis.dotlocalhost.com/addtea.php', sendData).then((result) => {
            if (result.data.Status == 'Invalid') {
                alert('Invalid User');
            } else {
                history('/viewalltea');
            }
        })

    }

    // start add product id from the database named products
    /*
    const [teaid, setTeaid] = useState("");

    useEffect(() => {
        // Fetch the last teaid and increment it
        axios.get("https://react-apis.dotlocalhost.com/getteaid.php")
            .then(response => {
                setTeaid(response.data.teaid); // Set the incremented teaid
            })
            .catch(error => {
                console.error("There was an error fetching the teaid!", error);
            });

    }, []);
    */

    return (
        <div class="wrapper">
            <Sidebar />
            <div id="content">
                <Navbar />

                <div className='ineerBody'>

                    <div className='row'>
                        <div className='col-md-12 mb-5'>
                            <h3>Add New Tea</h3>
                        </div>
                    </div>

                    <form onSubmit={submitForm}>
                        {/* 
                        <input style={{}} type="text" id="teaid" name='teaid' value={teaid} />
*/}
                        <div className='row'>
                            <div className='col-4'>
                                <Table striped bordered hover style={{ fontSize: '12px' }}>
                                    <thead>
                                        <tr style={{ textAlign: 'center', backgroundColor: '#C0D4D9', color: '#000000' }}>
                                            <th>#</th>
                                            <th><label>Grade</label></th>
                                            {/* <th>Quantity</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td><input type="text" name="grade" className='form-control' onChange={handleChange} value={data.grade} autocomplete="off" /></td>
                                        </tr>
                                    </tbody>
                                </Table>
                            </div>
                        </div>


                        <div className="row">
                            <div className='col-6'>
                                <div className="d-grid gap-3">
                                    <input type="submit" name="submit" value="Add Product" className="btn btn-primary btn-block" />
                                </div>
                            </div>
                        </div>

                    </form>

                </div>

            </div>
        </div>
    )
}

export default AddTea;